export default __webpack_public_path__ + "static/media/logo-1.4e5bbd3c.bin";